import { CSSProperties } from "react"
import { FieldErrors } from "react-hook-form"
import { StylesConfig } from "react-select"

interface iSelectStyle {
  isMulti: boolean
  noPadding?: boolean
  error?: FieldErrors
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export function selectStyle({
  isMulti,
  noPadding = false,
  error,
}: iSelectStyle): StylesConfig {
  return {
    valueContainer: (styles: CSSProperties): CSSProperties => ({
      ...styles,
      height: isMulti ? "auto" : styles.height,
      padding: noPadding ? "0 15px" : isMulti ? "5px 15px" : "0 15px",
    }),
    control: (styles: CSSProperties): CSSProperties => ({
      ...styles,
      height: "auto",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: error ? "#ed1c24" : "#d3d8de",
    }),
    menu: (styles: CSSProperties): CSSProperties => ({
      ...styles,
      marginTop: "2px",
      zIndex: 99,
    }),
  }
}
